import React, { useRef, useState } from 'react';

const MenuCategorias = ({ categorias, categoriaActual, onSeleccionarCategoria }) => {
    const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    // --- LÓGICA PARA ARRASTRAR CON EL MOUSE (TIPO TABLET) ---
    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Multiplicador de velocidad de arrastre
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    return (
        <div className="bg-white" style={{ zIndex: 1020 }}>
            
            <style>{`
                /* Barra de scroll visible pero elegante y delgadita */
                .menu-categorias-scroll::-webkit-scrollbar { 
                    height: 6px; 
                }
                .menu-categorias-scroll::-webkit-scrollbar-track { 
                    background: #f1f3f5; 
                    border-radius: 10px; 
                }
                .menu-categorias-scroll::-webkit-scrollbar-thumb { 
                    background: #cdd4da; 
                    border-radius: 10px; 
                }
                .menu-categorias-scroll::-webkit-scrollbar-thumb:hover { 
                    background: #aab2bd; 
                }

                .menu-categorias-scroll { 
                    /* Propiedades para el arrastre suave */
                    scroll-behavior: auto; 
                    cursor: grab;
                }
                
                /* Cambia el cursor cuando están arrastrando */
                .menu-categorias-scroll.active {
                    cursor: grabbing;
                }

                /* Estilo base del "Chip" */
                .cat-chip {
                    padding: 8px 22px;
                    border-radius: 50px;
                    font-weight: 600;
                    font-size: 0.95rem;
                    border: none;
                    white-space: nowrap;
                    transition: all 0.2s;
                    user-select: none; /* Evita que el texto se ponga azul al arrastrar */
                }

                .cat-chip:active {
                    transform: scale(0.95);
                }

                .cat-chip-inactive {
                    background-color: #f3f4f6;
                    color: #6b7280;
                }
                
                .cat-chip-inactive:hover {
                    background-color: #e5e7eb;
                    color: #374151;
                }

                .cat-chip-active {
                    background-color: #F26522; 
                    color: white;
                    box-shadow: 0 4px 10px rgba(242, 101, 34, 0.3);
                }
            `}</style>

            <div 
                ref={scrollRef}
                className={`d-flex overflow-auto py-3 px-3 menu-categorias-scroll ${isDragging ? 'active' : ''}`} 
                style={{ gap: '10px' }}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
            >
                
                <button
                    className={`cat-chip ${categoriaActual === null ? 'cat-chip-active' : 'cat-chip-inactive'}`}
                    onClick={() => onSeleccionarCategoria(null)}
                >
                    Todos
                </button>

                {categorias && categorias.map(c => (
                    <button
                        key={c.id || c.uuid}
                        className={`cat-chip ${categoriaActual === (c.id || c.uuid) ? 'cat-chip-active' : 'cat-chip-inactive'}`}
                        onClick={() => onSeleccionarCategoria(c.id || c.uuid)}
                    >
                        {c.nombre}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default MenuCategorias;